import * as React from "react";

function SetAsReferencePlate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="30"
      height="24"
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.1667 0.666748V23.3334H0.833344V4.91675L5.08334 0.666748H29.1667ZM5.08334 4.91675H9.33334V9.16675H5.08334V4.91675ZM10.75 4.91675H15V9.16675H10.75V4.91675ZM20.6667 4.91675H16.4167V9.16675H20.6667V4.91675ZM22.0833 4.91675H26.3333V9.16675H22.0833V4.91675ZM5.08334 10.5834H9.33334V14.8334H5.08334V10.5834ZM10.75 10.5834H15V14.8334H10.75V10.5834ZM20.6667 10.5834H16.4167V14.8334H20.6667V10.5834ZM22.0833 10.5834H26.3333V14.8334H22.0833V10.5834ZM9.33334 16.2501H5.08334V20.5001H9.33334V16.2501ZM15 16.2501H10.75V20.5001H15V16.2501ZM16.4167 16.2501H20.6667V20.5001H16.4167V16.2501ZM26.3333 16.2501H22.0833V20.5001H26.3333V16.2501Z"
        fill="white"
      />
    </svg>
  );
}

export default SetAsReferencePlate;
